@if (!formatTable) {
  <a id="dashboard-your-mortgage-widget" class="your-mortgage-container">
    <h3 class="h-main h-main-medium col-12 no-pd corporate colapse-h" (click)="collapseMortgage = !collapseMortgage">
      {{ 'your_mortgage_title' | translate }}
      <a
        href="javascript:;"
        class="colapse-arrow"
        [ngClass]="{
          'ic-arrow-short-down': collapseMortgage,
          'ic-arrow-short-up': !collapseMortgage,
        }"
      ></a>
    </h3>

    @if (status >= minStatus.simulation_done && !httpError) {
      <div
        [routerLink]="RESULT_NAME"
        class="your-mortgage"
        [class.disabled]="isRejected"
        [ngClass]="{ 'colapse-box colapsed': collapseMortgage }"
      >
        <div class="row">
          <div class="ball">
            <span class="ic ic-mortage"></span>

            @if (yourMortgage?.order) {
              <span> {{ yourMortgage?.order | number: '1.0-0' }} €</span>
            }
            <span>
              {{ yourMortgage?.years }}
              {{ 'your_mortgage_years' | translate }}</span
            >
            <div class="secondary-divider"></div>
            @if (yourMortgage?.share) {
              <span class="secondary-text"> {{ yourMortgage?.share | number: '1.2-2' }} €</span>
            }
          </div>

          @if (status === minStatus.simulation_done && substatus === minStatus.simulation_done_subtype_1) {
            <span class="has-error error-mortgage">
              {{ 'your_mortgage_error_mortgage_conditioned' | translate }}
            </span>
          }
        </div>

        @if (
          status > minStatus.simulation_done ||
          (status === minStatus.simulation_done && substatus === minStatus.simulation_done_subtype_2)
        ) {
          <div class="tin-tae">
            @if (yourMortgage?.numMonthsFixed !== 0) {
              <div class="row">
                <div class="col-6 text-align-left">
                  <span>{{
                    'your_mortgage_tin_n_months'
                      | translate
                        : {
                            months: yourMortgage?.numMonthsFixed ? yourMortgage?.numMonthsFixed : '-',
                          }
                  }}</span>
                  <a
                    class="icon-a"
                    href="javascript:void(0)"
                    tooltipEvent="hover"
                    appOpenToast
                    id="id-tooltip-tin-first-year"
                    [pTooltip]="
                      'tooltip_tin_first_n_months'
                        | translate
                          : {
                              months: yourMortgage?.numMonthsFixed ? yourMortgage?.numMonthsFixed : '-',
                            }
                    "
                  >
                    <img class="ico-info" src="assets/img/info.svg" />
                  </a>
                </div>

                @if (yourMortgage?.tin) {
                  <div class="col-6 text-align-right">
                    <span>{{ yourMortgage?.tin | number: '1.2-2' : 'es' }} %</span>
                  </div>
                }
              </div>
            }
            <div class="row">
              <div class="col-6 text-align-left">
                <span>{{ 'your_mortgage_euribor' | translate }}</span>
              </div>

              @if (yourMortgage?.differential) {
                <div class="col-6 text-align-right">
                  <span>{{ yourMortgage?.differential | number: '1.2-2' : 'es' }} %</span>
                </div>
              }
            </div>
            <div class="row">
              <div class="col-6 text-align-left">
                <span>{{ 'your_mortgage_tae' | translate }}</span>
              </div>
              @if (yourMortgage?.tae) {
                <div class="col-6 text-align-right">
                  <span>{{ yourMortgage?.tae | number: '1.2-2' : 'es' }} %</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <ng-template #statusFirst
        ><div class="your-mortgage">
          <div class="row">
            <div class="ball">
              <span class="ic ic-mortage"></span>

              @if (!httpError) {
                <span>{{ 'your_mortgage_result_info' | translate }}</span>
              } @else {
                <span>{{ 'your_mortgage_result_info_error' | translate }}</span>
              }

              <div class="secondary-divider"></div>
            </div>
          </div></div
      ></ng-template>
    }
  </a>
}

@if (status > minStatus.simulation_done && formatTable && yourMortgage) {
  <a id="dashboard-your-mortgage-table" [routerLink]="RESULT_NAME" class="your-mortgage-container-table">
    <h3 class="h-main h-main-medium col-12 no-pd corporate colapse-h">
      {{ 'your_mortgage_title' | translate }}
    </h3>
    <div class="your-mortgage-table row">
      <div class="col-md-6 col-12">
        <div class="tin-tae">
          <div class="row">
            <div class="col-6 text-align-left">
              <span class="mortgage-title"> {{ 'your_mortgage_amount' | translate }}</span>
            </div>
            <div class="col-6 text-align-right">
              @if (yourMortgage?.order) {
                <span class="nowrap numbers"> {{ yourMortgage?.order | number: '1.0-0' }} €</span>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-6 text-align-left">
              <span class="mortgage-title">{{ 'your_mortgage_years' | translate | capitalizeFirst }}</span>
            </div>
            <div class="col-6 text-align-right">
              <span class="nowrap numbers">
                {{ yourMortgage?.years }}
                {{ 'your_mortgage_years' | translate }}</span
              >
            </div>
          </div>
          @if (yourMortgage?.numMonthsFixed !== 0) {
            <div class="row">
              <div class="col-8 text-align-left">
                <span class="mortgage-title">{{
                  'your_mortgage_first_n_months'
                    | translate
                      : {
                          months: yourMortgage?.numMonthsFixed ? yourMortgage?.numMonthsFixed : '-',
                        }
                }}</span>
                <a
                  class="icon-a"
                  href="javascript:void(0)"
                  tooltipEvent="hover"
                  appOpenToast
                  id="simulation-result-tooltip-first-year-monthly-fee"
                  [pTooltip]="
                    'simulation_result_tooltip_first_n_month_monthly_fee'
                      | translate
                        : {
                            months: yourMortgage?.numMonthsFixed ? yourMortgage?.numMonthsFixed : '-',
                          }
                  "
                >
                  <img class="ico-info" src="assets/img/info.svg" />
                </a>
              </div>
              <div class="col-4 text-align-right">
                @if (yourMortgage?.share) {
                  <span class="nowrap numbers">{{ yourMortgage?.share | number: '1.2-2' }} €</span>
                }
              </div>
            </div>
          }

          @if (yourMortgage?.monthlyFee) {
            <div class="row">
              <div class="col-8 text-align-left">
                <span class="mortgage-title">{{
                  (yourMortgage?.numMonthsFixed !== 0
                    ? 'your_mortgage_fee_other_years'
                    : 'your_mortgage_fee_other_years_0_months'
                  ) | translate
                }}</span>
              </div>
              <div class="col-4 text-align-right">
                @if (yourMortgage?.monthlyFee) {
                  <span class="nowrap numbers">{{ yourMortgage?.monthlyFee | number: '1.2-2' }} €</span>
                }
              </div>
            </div>
          }

          @if (yourMortgage?.numMonthsFixed === 0) {
            <div class="row">
              <div class="col-8 text-align-left">
                <span class="mortgage-title">{{ 'your_mortgage_tin_label' | translate }}</span>
              </div>
              <div class="col-4 text-align-right">
                @if (yourMortgage?.tin) {
                  <span class="nowrap numbers">{{ yourMortgage?.tin | number: '1.2-2' }} €</span>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="tin-tae">
          @if (
            status > minStatus?.simulation_done ||
            (status === minStatus?.simulation_done && substatus === minStatus?.simulation_done_subtype_2)
          ) {
            <div class="tin-tae">
              @if (yourMortgage?.numMonthsFixed !== 0) {
                <div class="row">
                  <div class="col-6 text-align-left">
                    <span class="mortgage-title">
                      {{
                        'your_mortgage_tin_n_months'
                          | translate
                            : {
                                months: yourMortgage?.numMonthsFixed ? yourMortgage?.numMonthsFixed : '-',
                              }
                      }}
                    </span>
                    <a
                      class="icon-a"
                      href="javascript:void(0)"
                      tooltipEvent="hover"
                      appOpenToast
                      id="id-tooltip-tin-first-year"
                      [pTooltip]="
                        'tooltip_tin_first_n_months'
                          | translate
                            : {
                                months: yourMortgage?.numMonthsFixed ? yourMortgage?.numMonthsFixed : '-',
                              }
                      "
                    >
                      <img class="ico-info" src="assets/img/info.svg" />
                    </a>
                  </div>
                  <div class="col-6 text-align-right">
                    @if (yourMortgage?.tin) {
                      <span class="nowrap numbers">{{ yourMortgage?.tin | number: '1.2-2' : 'es' }} %</span>
                    }
                  </div>
                </div>
              }
              <div class="row">
                <div class="col-6 text-align-left">
                  <span class="mortgage-title">
                    {{ 'your_mortgage_tae' | translate }}
                  </span>
                </div>
                <div class="col-6 text-align-right">
                  @if (yourMortgage?.tae) {
                    <span class="nowrap numbers">{{ yourMortgage?.tae | number: '1.2-2' : 'es' }} %</span>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-align-left">
                  <span class="mortgage-title">
                    {{ 'your_mortgage_euribor' | translate }}
                  </span>
                </div>
                <div class="col-6 text-align-right">
                  <span class="nowrap numbers">{{ yourMortgage?.differential | number: '1.2-2' : 'es' }} %</span>
                </div>
              </div>

              @if (yourMortgage?.ltv) {
                <div class="row">
                  <div class="col-8 text-align-left">
                    <span class="mortgage-title">{{ 'your_mortgage_percentfinancing_percentage' | translate }}</span>
                  </div>
                  <div class="col-4 text-align-right">
                    @if (yourMortgage?.ltv) {
                      <span class="nowrap numbers">{{ yourMortgage?.ltv * 100 | number: '1.2-2' }} %</span>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </a>
}
